import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";


async function ObtenerListadoPonderacionService(idUsuario) {

    try {
        return await instance.Backend.post("/Indicador/ListaPonderaciones", 
        {
            IdUsuario: idUsuario
        }, customConfig);

    } catch (error) {
        console.log(error);
    }

}
export { ObtenerListadoPonderacionService };